import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyEn1() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`I.`}
            <br />
            {`Introductory provisions`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`These terms and conditions (hereinafter referred to as the "terms and conditions") of the operator of the website anandita.cz - Pavol Hudran, place of business Opava, Kateřinky, Zeyerova 1386/14, Company ID: 74869663 (hereinafter referred to as the "Provider") regulate, in accordance with the provisions of Section 1751 paragraph 1 of Act No. 89/2012 Coll., The Civil Code (hereinafter referred to as the "Civil Code  “), the mutual rights and obligations of the Contracting Parties arising in connection with the provision of access to the paid part of the anandita.cz website (hereinafter referred to as the "Agreement" or "service") concluded between the Provider and a third party (hereinafter referred to as the "User"), which consists in particular in making available the selected content and archive (hereinafter referred to as the "content") through the Provider's internet portal, which is operated on a website located at the internet address https://app.anandita.cz (including all subdomains and localized variants - hereinafter the "website").`}</li>
            <li>{`The legal relations between the Provider and the User, which are not regulated by these terms and conditions or the Agreement, are governed by the Civil Code and related regulations.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={3} className={sList}>
            <li>{`The wording of the terms and conditions may be unilaterally amended or supplemented by the Provider to a reasonable extent, in particular as a result of changes in legislation, technical conditions of website operation or changes in license conditions by third parties used by the Provider. The change of the terms and conditions will be notified to the User by e-mail to their e-mail address specified in the User account, if it was provided, or by displaying a notification after the User logs in to their User interface. The User may refuse to change the terms and conditions by terminating the Agreement for the provision of services with a notice period of 1 month, which begins on the first day of the monthly subscription period following the delivery of the notice and ends on the last day of such period. Termination can also be carried out by e-mail from the e-mail address specified in the User's User account or from the relevant e-mail of the Provider.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyEn1;
